export enum FieldType {
   BuiltInFieldText = -1,
   BuiltInFieldCheckBox = -2,
   BuiltInFieldInt32 = -3,
   BuiltInFieldDate = -4,
   BuiltInFieldBates = -5,
   BuiltInFieldDropDownList = -6,
   BuiltInFieldUniqueIdentifier = -7,
   SectionSeparator = 0,
   TextField = 1,
   CheckBox = 2,
   SharedCheckBox = 3,
   DropDownList = 4,
   DateTime = 5
}
